import React from 'react';
import { Button, Select } from '@uclaea/react-component-library';
import './css/Modal.css';

interface DownloadModalProps {
    selectedDownloadFormat: string;
    setSelectedDownloadFormat: (format: string) => void;
    onConfirm: () => void;
    onCancel: () => void;
}

const formatOptions = [
    { label: 'CSV', id: 'csv', value: 'csv' },
    { label: 'Excel', id: 'excel', value: 'excel' },
];

const DownloadModal: React.FC<DownloadModalProps> = ({ selectedDownloadFormat, setSelectedDownloadFormat, onConfirm, onCancel }) => {
    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={onCancel}>&times;</span>
                <h2>Select Download Format</h2>
                <Select
                    label="Format"
                    value={selectedDownloadFormat}
                    onChange={(e) => setSelectedDownloadFormat(e.target.value)}
                    options={formatOptions}
                />
                <br />
                <div className='modal-buttons'>
                    <Button variant="primary" label="Download" onClick={onConfirm} />
                    <Button variant="secondary" label="Cancel" onClick={onCancel} />
                </div>
            </div>
        </div>
    );
};

export default DownloadModal;
